import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-data",
  "use": "icon-data-usage",
  "viewBox": "-0.005 0.033 16.5 16.5",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"-0.005 0.033 16.5 16.5\" id=\"icon-data\"><path d=\"M14.662.033H1.828A1.84 1.84 0 0 0-.005 1.867V14.7c0 1.008.825 1.833 1.833 1.833h12.834a1.84 1.84 0 0 0 1.833-1.833V1.867A1.84 1.84 0 0 0 14.662.033M5.495 12.867H3.662V6.45h1.833zm3.667 0H7.328V3.7h1.834zm3.666 0h-1.833V9.2h1.833z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol